"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
var _excluded = ["variant", "borderSize", "borderRadius", "className", "disabled", "children", "clickMethod"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
var GradientButton = function GradientButton(_ref) {
  var _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? "contained" : _ref$variant,
    _ref$borderSize = _ref.borderSize,
    borderSize = _ref$borderSize === void 0 ? "3px" : _ref$borderSize,
    _ref$borderRadius = _ref.borderRadius,
    borderRadius = _ref$borderRadius === void 0 ? "48px" : _ref$borderRadius,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    children = _ref.children,
    _ref$clickMethod = _ref.clickMethod,
    clickMethod = _ref$clickMethod === void 0 ? function () {} : _ref$clickMethod,
    rest = _objectWithoutProperties(_ref, _excluded);
  if (variant === "contained") {
    return /*#__PURE__*/_react["default"].createElement(_material.Button, {
      sx: function sx(theme) {
        return _objectSpread(_objectSpread({
          color: "#5D52C2",
          fontWeight: 600,
          // Semibold
          whiteSpace: "nowrap",
          width: "100%",
          borderRadius: borderRadius,
          background: "linear-gradient(to right, #BBCDF6, #E2C2FE)",
          textTransform: "none"
        }, rest), {}, _defineProperty(_defineProperty({}, theme.breakpoints.up("md"), {
          paddingY: '0.75rem'
        }), theme.breakpoints.down("md"), {
          paddingY: '0.5rem'
        }));
      },
      onClick: clickMethod,
      disabled: disabled,
      className: className
    }, children);
  }
  if (variant === 'outlined') {
    return /*#__PURE__*/_react["default"].createElement(_material.Button, {
      sx: function sx(theme) {
        return _objectSpread(_objectSpread({
          color: "#5D52C2",
          fontWeight: 600,
          // Semibold
          whiteSpace: "nowrap",
          width: "100%",
          borderRadius: borderRadius,
          border: "double ".concat(borderSize, " transparent"),
          backgroundImage: "linear-gradient(to right, white, white), linear-gradient(to right, #BBCDF6, #E2C2FE)",
          backgroundOrigin: "border-box",
          backgroundClip: "padding-box, border-box",
          textTransform: "none"
        }, rest), {}, _defineProperty(_defineProperty({}, theme.breakpoints.up("md"), {
          paddingY: '0.75rem'
        }), theme.breakpoints.down("md"), {
          paddingY: '0.5rem'
        }));
      },
      onClick: clickMethod,
      disabled: disabled,
      className: className
    }, children);
  }
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null);
};
var _default = exports["default"] = GradientButton;